import React from "react";
import { ContentSection, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { CloudFileVideoTechnical } from "../../../CloudFileDetails";

interface VideoCloudFileTechnicalSectionProps {
    videoTechnical: CloudFileVideoTechnical;
    isLoading: boolean;
}

export const VideoCloudFileTechnicalSection = ({
    videoTechnical,
    isLoading
}: VideoCloudFileTechnicalSectionProps): JSX.Element => {
    return (
        <ContentSection header="Technical" isLoading={isLoading} style={{ height: 300 }}>
            <GridRow>
                <GridColumn sm={3}>
                    <LabeledText label="Format" value={videoTechnical.format} testId="Format" />
                    <LabeledText label="Encoding" value={videoTechnical.encoding} testId="Encoding" />
                    <LabeledText
                        label="Aspect type"
                        value={videoTechnical.aspectType?.name}
                        testId="aspect-type-field"
                    />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="FFProbe aspect ratio"
                        value={videoTechnical.fileAspectRatio}
                        testId="ffProbe-aspect-ratio-field"
                    />
                    <LabeledText
                        label="Aspect ratio"
                        value={videoTechnical.aspectRatio?.name}
                        testId="aspect-ratio-field"
                    />
                    <LabeledText label="Resolution" value={videoTechnical.resolution} testId="resolution-field" />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText label="Duration" value={videoTechnical.duration} testId="Duration" />
                    <LabeledText label="Framerate" value={videoTechnical.framerate} testId="framerate-field" />
                    <LabeledText label="Bit rate" value={videoTechnical.videoBitRate} testId="bit-rate-field" />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
